define([
    "angular",
    "./userPreferencesModule"
], function (angular, userPreferencesModule) {
    "use strict";
    userPreferencesModule.provider("planningUserPreferencesProperties", [function () {

        var isStoredPreferences;

        this.$get = [function () {
            return {
                isStorePreferencesActive: isStorePreferencesActive
            };
        }];

        function isStorePreferencesActive() {
            return isStoredPreferences;
        }

        this.setActivateStorePreferences = function (storePreferences) {
            isStoredPreferences = storePreferences;
        };
    }]);
});

